import { useFormik } from 'formik';
import React, { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useLocation } from 'react-router-dom';

import {
  WltSignInValidation,
} from '../../components/Validation/index.js';
import OneSignal from 'react-onesignal';
import { getProfileById, loginApi, verifyToken } from '../../apis/index.js';
import { AppContext } from '../../appContext/index.js';
import MobileLoginView from '../../PageComponent/Account/MobileLoginView.js';
import DesktopLoginView from '../../PageComponent/Account/DesktopLoginView.js';
import { getReferralFromUrl } from '../../utils/helperFunctions.js';


export default function GoogleSignIn({
  formGreetings,
  formSubGreetings,
  formType,
}) {
   const  { userDetails ,setUserDetails} =useContext(AppContext);
  const navigate = useNavigate();
    const location = useLocation();
  async function runOneSignal(id) {
    try {
      console.log(id)
      OneSignal.login(id)
      console.log('Login successful');
    } catch (error) {
      console.error('Error logging in:', error);
    }
  }
  const onVerifyToken = async (values) => {
     try {
      const response = await verifyToken(values);
      const data = response.data;
      if (response.status === 200) {
        localStorage.setItem('tempToken',response.data.token);
        localStorage.setItem('userId', response.data.userid);
        const res = await getProfileById(response.data.userid);
      if (res.status == 200) {
        if (res.data.Profile.DoctorProfile != null) {
          if (res.data.Profile.DoctorProfile.isApproved) {
            localStorage.setItem('token', response.data.token);
            setUserDetails(res.data.Profile);
            await runOneSignal(res.data.Profile.DoctorProfile?._id)
            navigate('/');
          } else {
              const referral = await getReferralFromUrl();
              if (referral) {
                navigate(`/registration?Referral_code=${encodeURIComponent(referral)}`, {
                  replace: true,
                });
              }
              else{
                 navigate('/registration');
              }
            
          }
        } else {
            const referral = await getReferralFromUrl();
              if (referral) {
                navigate(`/registration?Referral_code=${encodeURIComponent(referral)}`, {
                  replace: true,
                });
              }
              else{
                 navigate('/registration');
             }
        }
      }
      } 
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message, { id: '001' });
    }
  };
  const responseMessage = (response) => {
    console.log(response)
    const values = { token: response.credential };
    onVerifyToken(values);
  };
  const errorMessage = (error) => {
    console.log(error);
  };

  const formik = useFormik({
    initialValues: { email: '', keepLoggedIn: false },
    validationSchema: WltSignInValidation,
    onSubmit: async (values) => {
      const { email } = values;
      try {
        setLoader(true);
        const res = await loginApi({ email });
        if (res.status === 200) {
          toast.success(res.data.message);
          navigate('/otp', {
            state: {
              email: formik.values.email,
              keepLoggedIn: formik.values.keepLoggedIn,
            },
          });
        }
      } catch (error) {
        setLoader(false);
        const message =
          error.response.data.message || error.response.statusText;
        toast.error(message, { id: 'error' });
      }
    },
  });
  const [loader, setLoader] = useState(false);

  return (
    <>
      {window?.innerWidth < 1024 ? (
        <MobileLoginView
          formGreetings={formGreetings}
          formSubGreetings={formSubGreetings}
          formType={formType}
          onVerifyToken={(val) => { onVerifyToken(val) }}
          runOneSignal={runOneSignal}
          referral={getReferralFromUrl()}
        />
      ) : (
        <DesktopLoginView
          formGreetings={formGreetings}
          formSubGreetings={formSubGreetings}
          responseMessage={responseMessage}
          errorMessage={errorMessage}
          runOneSignal={runOneSignal}
          formType={formType}
           referral={getReferralFromUrl()}
        />
      )}


    </>
  );
}

